// src/components/common/audio-player/ui/AudioSeekBar.tsx

"use client";
import React from "react";
import { Undo, Redo } from "lucide-react";

import "./AudioSeekBar.css";

type Props = {
  time: number;
  duration: number;
  bufferedPct: number;
  playedPct: number;
  onSeek: (t: number) => void;
  onSkip: (delta: number) => void;
  fmt: (n: number) => string;
};

const AudioSeekBar: React.FC<Props> = ({
  time,
  duration,
  bufferedPct,
  playedPct,
  onSeek,
  onSkip,
  fmt
}) => {
  return (
    <div className="tl-row tl-seek-row">
      <button className="tl-icon-btn" onClick={() => onSkip(-5)} aria-label="Back 5 seconds">
        <Undo size={20} strokeWidth={1.4} /> -
      </button>

      <div className="tl-progress">
        <span className="tl-time">{fmt(time)}</span>

        <div className="tl-bar">
          <div className="tl-buffered" style={{ width: `${bufferedPct}%` }} />
          <div className="tl-played" style={{ width: `${playedPct}%` }} />
          <input
            className="tl-seek"
            type="range"
            min={0}
            max={Math.max(0, Math.floor(duration))}
            step={1}
            value={Math.floor(time)}
            onChange={(e) => onSeek(Number(e.target.value))}
            aria-label="Seek"
          />
        </div>

        <span className="tl-time">-{fmt(Math.max(0, duration - time))}</span>
      </div>

      <button className="tl-icon-btn" onClick={() => onSkip(+5)} aria-label="Forward 5 seconds">
        + <Redo size={20} strokeWidth={1.4} />
      </button>
    </div>
  );
};

export default AudioSeekBar;
